module.exports = __webpack_public_path__ + "static/media/starts_with_b.5cc4cd0e.mp3";